// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msg_container__XEaGe {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    width: 90%;
    max-width: 500px;
    background-color: #fff;
    color: #303030;
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
    padding: 30px 20px;
    margin: 80px auto;
    text-align: center;
    animation: msg_fadeIn__ayhR\\+ 0.4s ease-in-out;
}

.msg_logoContainer__xZOB- {
  width: 100%;
  display: flex;
  justify-content: center;
}

.msg_content__7evnL {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.msg_title__-0I7j {
    font-size: 24px;
    margin-bottom: 10px;
}

.msg_text__P9oVe {
    font-size: 18px;
    margin-bottom: 20px;
}

.msg_progressSection__698Ne {
    width: 100%;
}

.msg_countdown__6T4cO {
    font-size: 14px;
    color: #888;
    margin-bottom: 5px;
}

/* Já definidos anteriormente */
.msg_progressBarContainer__TbtZB {
    width: 100%;
    height: 8px;
    background-color: #ddd;
    border-radius: 4px;
    overflow: hidden;
}

.msg_progressBar__osSM0 {
    height: 100%;
    width: 100%;
    background-color: #f03e3e;
    animation: msg_shrink__ImJKt 5s linear forwards;
    transform-origin: left;
}

/* Animações */
@keyframes msg_shrink__ImJKt {
    from { transform: scaleX(1); }
    to { transform: scaleX(0); }
}

@keyframes msg_fadeIn__ayhR\\+ {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

@media only screen and (max-width: 600px) {
    .msg_container__XEaGe {
        width: 90%;
        margin: 40px auto;
        padding: 20px 10px;
    }

    .msg_title__-0I7j {
        font-size: 20px;
    }

    .msg_text__P9oVe {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/research/msg.module.css"],"names":[],"mappings":"AAAA;IACI,4DAA4D;IAC5D,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,8CAAkC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,+CAAoC;IACpC,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,OAAO,oBAAoB,EAAE;IAC7B,KAAK,oBAAoB,EAAE;AAC/B;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    width: 90%;\n    max-width: 500px;\n    background-color: #fff;\n    color: #303030;\n    border-radius: 20px;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.2);\n    padding: 30px 20px;\n    margin: 80px auto;\n    text-align: center;\n    animation: fadeIn 0.4s ease-in-out;\n}\n\n.logoContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.title {\n    font-size: 24px;\n    margin-bottom: 10px;\n}\n\n.text {\n    font-size: 18px;\n    margin-bottom: 20px;\n}\n\n.progressSection {\n    width: 100%;\n}\n\n.countdown {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 5px;\n}\n\n/* Já definidos anteriormente */\n.progressBarContainer {\n    width: 100%;\n    height: 8px;\n    background-color: #ddd;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.progressBar {\n    height: 100%;\n    width: 100%;\n    background-color: #f03e3e;\n    animation: shrink 5s linear forwards;\n    transform-origin: left;\n}\n\n/* Animações */\n@keyframes shrink {\n    from { transform: scaleX(1); }\n    to { transform: scaleX(0); }\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n@media only screen and (max-width: 600px) {\n    .container {\n        width: 90%;\n        margin: 40px auto;\n        padding: 20px 10px;\n    }\n\n    .title {\n        font-size: 20px;\n    }\n\n    .text {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `msg_container__XEaGe`,
	"fadeIn": `msg_fadeIn__ayhR+`,
	"logoContainer": `msg_logoContainer__xZOB-`,
	"content": `msg_content__7evnL`,
	"title": `msg_title__-0I7j`,
	"text": `msg_text__P9oVe`,
	"progressSection": `msg_progressSection__698Ne`,
	"countdown": `msg_countdown__6T4cO`,
	"progressBarContainer": `msg_progressBarContainer__TbtZB`,
	"progressBar": `msg_progressBar__osSM0`,
	"shrink": `msg_shrink__ImJKt`
};
export default ___CSS_LOADER_EXPORT___;
